/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class User {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List Available Organizations.
   *
   * @tags User
   * @name ListAvailableOrganizations
   * @summary List Available Organizations
   * @request GET:/api/user/organizations/available
   * @secure
   */
  listAvailableOrganizations = (params = {}) =>
    this.http.request({
      path: `/api/user/organizations/available`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Select Organizations.
   *
   * @tags User
   * @name SelectOrganizations
   * @summary Select Organizations
   * @request POST:/api/user/organizations/select
   * @secure
   */
  selectOrganizations = (data, params = {}) =>
    this.http.request({
      path: `/api/user/organizations/select`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Selected Organizations.
   *
   * @tags User
   * @name GetSelectedOrganizations
   * @summary Get Selected Organizations
   * @request GET:/api/user/organizations/selected
   * @secure
   */
  getSelectedOrganizations = (params = {}) =>
    this.http.request({
      path: `/api/user/organizations/selected`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deselect Organization.
   *
   * @tags User
   * @name DeselectOrganization
   * @summary Deselect Organization
   * @request DELETE:/api/user/organizations/select/{organization_id}
   * @secure
   */
  deselectOrganization = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/user/organizations/select/${organizationId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
}
